module.exports = __webpack_public_path__ + "img/thumbnail_LionTailedMacaque_m_normal.0f8b64c2.png";